import { ComponentType } from 'react';
import styled from 'styled-components';

export const StyledLink = styled.a<{
  LeftIcon: ComponentType<any>;
  $noWrap: boolean;
}>`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.blue5};
  position: relative;
  font-size: 14px;
  font-weight: 600;
  display: inline;
  line-height: 1.29;
  background: transparent;
  border: 0;
  padding: 1px 2px;
  margin: -1px -2px;
  outline: 0;
  border-radius: 3px;

  ${({ $noWrap }) => $noWrap && `
    display: inline-block;
    white-space: nowrap;
  `}

  ${({ LeftIcon }) => LeftIcon && `
    padding-left : 24px;
  `}

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }
`;

const StyledIcon = styled.svg`
  width: 18px;
  height: 18px;
  position: relative;
  top: 4px;
  margin-top: -3px;
`;

export const StyledLeftIcon = styled(StyledIcon)`
  margin-right: 3px;
  position: absolute;
  left: 0;
`;

export const StyledRightIcon = styled(StyledIcon)`
  margin-left: 3px;
`;
